module.exports = __webpack_public_path__ + "2add1454648668c1ffbae3e74ed58617.pdf";